export const SCORING_CRITERIA = [
  { key: "impact", label: "Impact Score", description: "Expected societal/outcome impact", defaultWeight: 40 },
  { key: "feasibility", label: "Feasibility Score", description: "Operational and technical feasibility", defaultWeight: 35 },
  { key: "budgetEfficiency", label: "Budget Efficiency Score", description: "Cost-effectiveness of the requested budget", defaultWeight: 25 },
];

export const STATUS_META = {
  pending: { label: "Pending", classes: "bg-ink-100 text-ink-700" },
  in_review: { label: "In Review", classes: "bg-amber-100 text-amber-800" },
  evaluated: { label: "Evaluated", classes: "bg-green-100 text-green-800" },
  archived: { label: "Archived", classes: "bg-ink-100 text-ink-500" },
  not_started: { label: "Not Started", classes: "bg-ink-100 text-ink-600" },
  draft: { label: "Draft", classes: "bg-amber-100 text-amber-800" },
  submitted: { label: "Submitted", classes: "bg-green-100 text-green-800" },
};

export function computeWeightedAverage(scores) {
  if (!Array.isArray(scores) || scores.length === 0) return 0;
  let weighted = 0;
  let total = 0;
  for (const s of scores) {
    const w = Number(s.weight) || 0;
    weighted += Number(s.score) * w;
    total += w;
  }
  if (total === 0) return 0;
  return Math.round((weighted / total) * 100) / 100;
}

export function scoreBand(score) {
  if (score == null) return { label: "—", classes: "text-ink-400" };
  if (score >= 80) return { label: "Strong", classes: "text-green-700" };
  if (score >= 60) return { label: "Moderate", classes: "text-amber-700" };
  if (score >= 40) return { label: "Weak", classes: "text-orange-700" };
  return { label: "Poor", classes: "text-red-700" };
}

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value || 0);

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" }) : "—";
